import React from 'react';
import { useDispatch } from "react-redux";
import { downloadFile } from "../../redux/slices/file";
import { StyledButton } from '../../styles/Styledbutton';
import { StyledDownloadIcon } from '../../styles/StyledDownloadIcon';

export const DownloadButton = ({ termsId, termsItemId, revision, onFileDownloaded, documentName }) => {
  const dispatch = useDispatch();

  const handleDownload = () => {
    dispatch(downloadFile({ termsId, termsItemId, revision, documentName }));
    onFileDownloaded();
  };

  return  (
    <StyledButton onClick={handleDownload}>
      <>
        <StyledDownloadIcon />
        <span>Download</span>
      </>
    </StyledButton>
  );
};
